import React from "react";
import { SurveyAnalysis } from "./survey-analyses-types";

interface SurveyAnalysisComponentProps {
  analysis: SurveyAnalysis;
}

export const SurveyAnalysisComponent: React.FC<
  SurveyAnalysisComponentProps
> = ({ analysis }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="bg-slate-800 p-4 text-sm">
        <h3 className="text-xl mb-4">Insights</h3>
        <ul className="list-disc list-inside">
          {analysis.insights.map((insight, index) => (
            <li key={index}>{insight}</li>
          ))}
        </ul>
      </div>
      <div className="bg-slate-800 p-4 text-sm">
        <h3 className="text-xl mb-4">Follow-up questions</h3>
        <ul className="list-disc list-inside">
          {analysis.followupQuestions.map((fup, index) => (
            <li key={index}>{fup}</li>
          ))}
        </ul>
        <div className="mt-4">
          <button
            className="btn-primary"
            onClick={() => alert("Not implemented yet ;)")}
          >
            Insert into the current survey
          </button>
          <button
            className="btn-primary"
            onClick={() => alert("Not implemented yet ;)")}
          >
            Insert into a new survey
          </button>
        </div>
      </div>
      <div className="bg-slate-800 p-4 text-sm">
        <h3 className="text-xl mb-4">Action Recommendations</h3>
        <ul className="list-disc list-inside">
          {analysis.actionRecommendations.map((action, index) => (
            <li key={index}>{action}</li>
          ))}
        </ul>
      </div>
      <div className="bg-slate-800 p-4 text-sm">
        <h3 className="text-xl mb-4">Conclusion</h3>
        {analysis.conclusion}
      </div>
    </div>
  );
};
